<template>
  <guide-button v-if="btnVisialbe && !hideBtn" class="pos-c" @click="next">{{ btnText }}</guide-button>
</template>

<script>
export default {
  name: 'NarrateAudio',
  data () {
    return {
      btnVisialbe: false,
      filename: '',
      btnText: '继续',
      auto: false,
      hideBtn: false,
      audio: document.createElement('AUDIO'),
    }
  },
  watch: {
    '$route.fullPath' () {
      this.clear()
      this.hideBtn = true
    },
  },
  created () {
    this.audio.onended = this.handleEnded
  },
  methods: {
    callback () {},
    onended () {},

    handleEnded () {
      this.onended()
      if (this.auto) {
        this.next()
      } else {
        this.btnVisialbe = true
      }
    },
    play () {
      if (this.filename) {
        this.audio.src = require(`../assets/audio/narrate/gai${this.filename}.mp3`)
        this.audio.play()
      }
    },
    pause () {
      this.audio.pause()
    },
    next () {
      this.clear()
      this.callback()
    },
    clear () {
      this.pause()
      this.btnVisialbe = false
    },
    skip () {
      this.pause()
      if (!this.hideBtn) {
        this.btnVisialbe = true
      }
      if (this.auto) {
        this.next()
      }
    },
  },
}
</script>
